<template>
  <!-- 项目管理 活动开展 查看详细-->
    <div class="ProjectManagement3_1" v-loading="loading">
        <markeractivityWordShow :wordData="wordData" :total="total"/>
    </div>
</template>

  <script>
  // import { uuid } from 'vue-uuid';
  import markeractivityWordShow from './markeractivityWordShow.vue'
      export default {
        props:['AidShow'],
        components:{markeractivityWordShow},
        data() {
          return {
            loading:false,
            wordData:{
                  acId:"",//活动ID
                  applicationDate:'',//申请日期
                  associatedProjects:"",//关联项目
                  ProjectName:"",//关联项目名称
                  activityName:'',//活动名称
                  pro_leader:"",//活动负责人
                  college: '',//所在学院ID
                  collegeName:"",//所在学院名称
                  tel:'',//联系电话
                  activityTime:"",//活动时间
                  student:0,//参与学生人数
                  member:[
                    {name:"",collage:"",work:""},
                    {name:"",collage:"",work:""},
                    {name:"",collage:"",work:""},
                    {name:"",collage:"",work:""},
                    {name:"",collage:"",work:""},
                  ],
                  activityPlan:"",//活动计划
                  expectations:"",//预期目标
                  eventAudience:"",//活动受众面
                  fundingPlan:"",//经费支出计划
                  expenditureMothPlan:['','','','','','','','','','','',''],
                  fund:{
                    device:"",
                    Material:"",
                    processing:"",
                    Collaboration:"",
                    APPRAISAL:"",
                    entery:"",
                    activities:"",
                    Transaction:"",
                  },//预算经费
                  type:0,//0 创客活动 1 个人创客
                  state:1,//项目状态 0未审核 1待报销 2 已审核 3 已报销
                }
          }
        },
        methods:{
          getData(){
                this.loading = true;
                let pram = {
                    uid:this.$store.state.userInfo.userid,
                    acid:this.AidShow,
                }
                this.ajax.get(this.$store.state.api+"/getActivityWordData",pram).then(result=>{
                  console.log(result)
                    let data = result['data'][0][0]
                    this.wordData['applicationDate'] = data['applicationDate'];
                    this.wordData['associatedProjects'] = data['pid'];
                    this.wordData['activityName'] = data['title'];
                    this.wordData['pro_leader'] = data['pro_leader'];
                    this.wordData['college'] = data['classid'];
                    this.wordData['tel'] = data['phone']
                    this.wordData['activityTime'] = JSON.parse(data['begin_at']);
                    this.wordData['student'] = data['students'];
                    this.wordData['member'] = JSON.parse(data['course_teacher']);
                    this.wordData['expenditureMothPlan'] = JSON.parse(data['MothPlan']);
                    this.wordData['fund'] = JSON.parse(data['fund']);
                    this.wordData['type'] = data['type'];
                    this.wordData['ProjectName'] = data['PName'];
                    this.wordData['collegeName'] = data['CName'];
                    this.wordData['acId'] = data['acId']
                    this.wordData['state'] = data['state']
                    this.wordData = {...this.wordData,...JSON.parse(data['chapters'])}
                    this.loading = false;
                }).catch(err=>{
                    console.log(err)
                })
              },
             
        },
        computed:{
            total() {
              let num = 0;
              for(let i in this.wordData['fund'])num += Number(this.wordData['fund'][i]);
              return num;
              // return (this.wordData.fund.facility*1 + this.wordData.fund.materials*1+this.wordData.fund.process*1+ this.input*1+this.wordData.fund.authenticate*1+ this.wordData.fund.match*1+this.wordData.fund.activity*1+this.wordData.fund.affair*1)/10000
            }
        },
        mounted(){
          this.getData();
          console.log(555);
        }
      }
  </script>

  <style lang="less">
   
  </style>

  
  